import { render, staticRenderFns } from "./ManagementCustomProperty.vue?vue&type=template&id=b39cd0d2&"
import script from "./ManagementCustomProperty.vue?vue&type=script&lang=ts&"
export * from "./ManagementCustomProperty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports